import React, {useEffect, useContext, useState} from "react"
import { useTranslation } from "react-i18next";

//MUI
import { Share } from "@mui/icons-material";

// Openlayers
import OlFeature from 'ol/Feature'
import OlFormatWKT from "ol/format/WKT";

// Custom
import InfoPaneActionButton from "./InfoPaneActionButton";
import MapContext from "@/components/Map/MapContext";
import api from "@/lib/api";
import PublicShareDialog from "@/ui/PublicPage/PublicShareDialog"
import DialogContext from "@/ui/DialogContext/DialogContext";
import { IInfoPane } from "@/@types/views/GIS/map";

type InfoPaneShareActionButtonProps = {
    infoPane?: IInfoPane;
    object_type?: string;
    feature?: OlFeature;
    wkt?: string;
}

const InfoPaneShareActionButton = (props: InfoPaneShareActionButtonProps) => {

    const [shareUrl, setShareUrl] = useState("");

    const { infoPane, object_type, wkt } = props;
  
    const mapContext = useContext(MapContext);
    const dialogContext = useContext(DialogContext);

    const handleShare = () => {
        const apiInstance = new api();
    
        if (!mapContext || !mapContext.map) return;
    
        const position = infoPane?.data.feature?.getGeometry().getCoordinates();

        let feature;
        if (props.feature) {
          feature = props.feature
        } else if (infoPane) {
          feature = infoPane?.data.feature;
        } else if (wkt) {
          const wktFormatter = new OlFormatWKT();
          feature = wktFormatter.readFeature(wkt, {
            dataProjection: "EPSG:3765",
            featureProjection: "EPSG:3857"
          })
        }

        if (feature) {
          const extent = feature.getGeometry()?.getExtent();
    
          const maplayers = localStorage.getItem("maplayers");
          const route_points = localStorage.getItem("route_points");
    
          const config = {
            position: position,
            extent: extent,
            maplayers: maplayers,
            route_points: object_type === "route" && route_points ? JSON.parse(route_points) : undefined,
            // @ts-ignore
            obilaznica_id: infoPane?.data?.record?.id
          };

          // @ts-ignore
          const object_id = object_type === "obilaznica" ? infoPane?.selectedPoiId
            : infoPane?.secondaryId ? infoPane?.secondaryId
            // @ts-ignore
            : infoPane?.record?.id ?? infoPane?.data?.record?.id;
    
          const data = {
            config: JSON.stringify(config),
            object_id: object_id,
            object_type: object_type,
          };
    
          apiInstance.Call("share-generate", "post", data).then((resp) => {
            // @ts-ignore
            if (resp.success && resp?.data?.url_hash) {
              setShareUrl(
                // @ts-ignore
                `${window.location.origin}/share?hash=${resp.data.url_hash}`
              );
            }
          });
        }
    };

    useEffect(()=>{
        if (shareUrl!=="")
        dialogContext.showDialog(PublicShareDialog,
            {url: shareUrl, record: infoPane?.data.record, type: infoPane?.type, subtype: infoPane?.subtype}
        )
    }, [shareUrl])

    return(
        <InfoPaneActionButton
        title_ttoken={"buttons.share"}
        icon={<Share sx={{transform: "scale(0.8)"}} color="primary" fontSize="large"></Share>}
        onClick={(evt)=>{handleShare()}}
        />
    )

}

export default InfoPaneShareActionButton;